export enum ContractDocumentType {
  INFO = 1,
  RESULT = 2,
  CONTRACT = 3,
}
